import { BehaviorSubject } from "rxjs";

/**
 * Set cookie
 * See actions in src/routes/(app)/+page.server.ts
 * The root route's action handler does of course not have to only be used to set cookie, but for now it does.
 */
export async function setCookie(key: string, value: string) {
	const formData = new FormData();
	formData.append(`mrd_${key}`, value);

	try {
		await fetch(`/?/${key}`, {
			method: "POST",
			// Set the FormData instance as the request body
			body: formData,
		});
		// See comment
		// cookies[key] = value;
		// cookieSub$.next(cookies);
	} catch (e) {
		console.error('Unable to set cookie.', e);
	}
}

/**
 * TODO: @Michiel - this won't get the initial cookie states, chat to Dan
 * (although we don't seem to need this anymore)
 * @deprecated see above
 */
const cookies = {} as Record<string, string>;
const cookieSub$ = new BehaviorSubject(cookies);
export const cookies$ = cookieSub$.asObservable();

export function doesCookieExist(cookieName: string): boolean {
  const cookies = document.cookie.split(';');
	let hasCookieName = false;
	cookies.map(cookie => {
		const [name, value] = cookie.split('=');
		name.trim() === cookieName ? hasCookieName = true : hasCookieName = false;
	})
  return hasCookieName;
}